// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2jUrE","vLegacy":"SelectSecondary_vLegacy__bzEF8","error":"SelectSecondary_error__3xhrh","disabled":"SelectSecondary_disabled__4hJZK"};